import { ObservableArray, View } from "binder"
import { ProductImageManipulationViewModel } from "./productImageManipulation-viewModel"
import { singleFile } from "../productImages-viewModel";
import { FileChooser } from "src/common/utilities";

export class ProductImageManipulationView extends View<ProductImageManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-9098A076-7DAF-4CA4-8D7F-B775F4F4598C"
    }
    loadHtml(): string {
        let element = require('./productImageManipulation.html').default;
        let style = require('./productImageManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set isWrecked(v: boolean) { this._isWrecked = v; } public get isWrecked(): boolean { return this._isWrecked;} private _isWrecked: boolean;
    public set hasPicture(v: boolean) { this._hasPicture = v; } public get hasPicture(): boolean { return this._hasPicture;} private _hasPicture: boolean;
    public set locations(v: string) { this._locations = v; } public get locations(): string { return this._locations;} private _locations: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set files(v: ObservableArray<singleFile>) { this._files = v; } public get files(): ObservableArray<singleFile> { return this._files;} private _files: ObservableArray<singleFile>;
    public set capturedPicture(v: string) { this._capturedPicture = v; } public get capturedPicture(): string { return this._capturedPicture;} private _capturedPicture: string;
    
    save(){
        this.dataContext.save();
    }
    back(){
        this.dataContext.back();
    }

    addFile(){
        this.dataContext.addFile();
    }
}
